import { UniqueFieldDropdown } from '@crm/api'

import { ImportHeader, UniqueFields } from '../pages'

export const buildFields = (
  items: UniqueFieldDropdown[],
  headers?: ImportHeader[]
): UniqueFields => {
  const headerMap = new Map(
    (headers ?? [])
      .filter((header) => header.key)
      .map((header) => [header.key!, header.column_index])
  )

  return items.map((item) => ({
    name: item.key,
    column_index: headerMap.get(item.key) ?? -1
  }))
}
